// Modello e validazione indipendenti dalla UI, usati anche dai test locali.
export const CUSTOMER_RETURN_DRAFT_KEY = "qualita_customer_return_draft_local";

export const RETURN_MANAGEMENT_OPTIONS = [
    { code: "901", description: "materiale non conforme accettato in deroga" },
    { code: "902", description: "reso da rifare in garanzia" },
    { code: "903", description: "reso da riparare in garanzia" },
    { code: "904", description: "reso da rifare e rivendere con emissione nota accredito" },
    { code: "906", description: "reso da riparare con emissione nota accredito" },
    { code: "907", description: "reso riparabile ma non consegnabile con emissione nota accredito" },
    { code: "908", description: "reso da scartare non consegnabile con emissione nota accredito" },
    { code: "909", description: "reso materiale conforme ma non consegnabile con emissione nota accredito" },
];

export function localTodayIso(referenceDate = new Date()) {
    return new Date(referenceDate.getTime() - referenceDate.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export function newReturnLine(id = Date.now()) {
    return {
        id,
        article: "",
        description: "",
        quantity: 1,
        managementCode: "",
        problem: "",
    };
}

export function newCustomerReturnDraft() {
    return {
        customerCode: "",
        addressCode: "",
        customerDocument: "",
        customerDocumentDate: localTodayIso(),
        lines: [newReturnLine()],
    };
}

export function validateCustomerReturnDraft(draft) {
    const errors = [];
    if (!draft.customerCode) errors.push("Selezionare il cliente consegnato.");
    if (!draft.addressCode) errors.push("Selezionare l'indirizzo cliente.");
    if (!draft.customerDocument || !draft.customerDocument.trim()) errors.push("Indicare il numero DDT cliente.");
    if ((draft.customerDocument || "").trim().length > 20) errors.push("Il numero DDT cliente non può superare 20 caratteri.");
    if (!draft.customerDocumentDate) errors.push("Indicare la data DDT cliente.");
    if (!draft.lines || draft.lines.length === 0) errors.push("Inserire almeno una riga di reso.");

    (draft.lines || []).forEach((line, index) => {
        const prefix = `Riga ${index + 1}`;
        if (!line.article || !line.article.trim()) errors.push(`${prefix}: indicare l'articolo.`);
        if (!Number(line.quantity) || Number(line.quantity) <= 0) errors.push(`${prefix}: la quantità deve essere maggiore di zero.`);
        if (!line.managementCode) errors.push(`${prefix}: selezionare la gestione.`);
        if (!line.problem || !line.problem.trim()) errors.push(`${prefix}: descrivere il problema segnalato dal cliente.`);
    });
    return errors;
}

export function validateDeliveredQuantities(lines, deliveredArticles) {
    const requestedByArticle = {};
    (lines || []).forEach((line) => {
        if (!line.article || Number(line.quantity) <= 0) return;
        requestedByArticle[line.article] = (requestedByArticle[line.article] || 0) + Number(line.quantity);
    });
    return Object.entries(requestedByArticle).reduce((errors, [articleCode, requestedQuantity]) => {
        const deliveredArticle = (deliveredArticles || []).find((article) => article.codice === articleCode);
        if (!deliveredArticle) {
            errors.push(`Articolo ${articleCode}: non risulta consegnato al cliente negli ultimi sei mesi.`);
            return errors;
        }
        const deliveredQuantity = Number(deliveredArticle.quantita_consegnata);
        if (requestedQuantity > deliveredQuantity) {
            errors.push(
                `Articolo ${articleCode}: quantità resa ${requestedQuantity} superiore alla quantità consegnata (${deliveredQuantity}).`
            );
        }
        return errors;
    }, []);
}

export function buildCustomerReturnPayload(draft) {
    return {
        service: "WS_SRH",
        header: {
            BPCORD: draft.customerCode,
            BPCINV: draft.customerCode,
            BPAADD: draft.addressCode,
            ENTRTNDAT: localTodayIso(),
            XXI0_ENCLDDT: draft.customerDocument.trim(),
            XXI0_ENDATDT: draft.customerDocumentDate,
        },
        lines: draft.lines.map((line) => ({
            ITMREF: line.article.trim().toUpperCase(),
            QTY: Number(line.quantity),
            YGESTNC: line.managementCode,
            YDSCGESTNC: line.problem.trim(),
        })),
    };
}
